import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import Pin from './pin.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <Pin {...validProps} />;
}
SvgComponent.iconName = 'pin';

/**
 * @deprecated This is a legacy icon
 */
export const PinIcon = svgIconWrapper(SvgComponent);
